import Adb from "@mui/icons-material/Adb";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import type { FC } from "react";
import { useFormContext } from "react-hook-form";
import toast from "react-hot-toast";
import { useFlags } from "../../../server/optimizely";
import { useDialog } from "../../../utils/hooks/use-dialog";
import type { MomentFormMoment } from "../types/moment-form-moment";

export const MomentFormDebug: FC = () => {
  const {
    flags: { debug },
  } = useFlags("debug");

  const { getValues } = useFormContext<MomentFormMoment>();
  const dialogController = useDialog();

  if (!debug) return null;

  return (
    <>
      <IconButton data-analytics-id="debug-moment-button" onClick={dialogController.handleOpen}>
        <Adb />
      </IconButton>
      <Dialog open={dialogController.open} onClose={dialogController.handleClose} fullWidth>
        <DialogTitle>Debug</DialogTitle>
        <DialogContent>
          <pre style={{ width: "100%" }}>{JSON.stringify(getValues(), undefined, 2)}</pre>
        </DialogContent>
        <DialogActions>
          {/* Copy to clipboard */}
          <Button
            data-analytics-id="copy-moment-debug-button"
            onClick={() => {
              void navigator.clipboard
                .writeText(JSON.stringify(getValues(), undefined, 2))
                .then(() => {
                  toast("Copied to clipboard");
                });
            }}
          >
            Copy to clipboard
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
